export const ZERO = 0;

export const START_INDEX = 0;

export const MAX_VISIBLE_PROMPTS = 3;

export const ONE = 1;

export const THREE = 3;

export const NOTIFICATION_MIN_COUNT = 0;

export const PRODUCTION = 'production';

export const NEGATIVE_ONE = -1;
export const FOUR = 4;
export const TWO = 2;
export const FIVE = 5;
export const ADMIN = 'admin';
export const STUDIO = 'studio';
export const LOCAL_HOST = 'localhost';
export const REDIRECT_URL_COOKIE_KEY = 'redirectURL';
export const LAST_TWO_IN_ARRAY = -2;
export const DEV_ZINIER_DOMAIN = 'devzinier.net';
export const ZINIER_DOMAIN = 'zinier.net';

export const getDomain = () => {
  if (window.location.hostname === LOCAL_HOST) {
    return DEV_ZINIER_DOMAIN;
  }
  return window.location.hostname.split('.').slice(LAST_TWO_IN_ARRAY).join('.');
};
export const isPreprodURL = () => {
  return window.location.hostname.split('.')[window.location.hostname.length - THREE] === 'preprod';
};

export const DEFAULT_USER_APP = 'user';
export const DECIMAL_EIGHTY = 0.8;

export const FLOAT_LEFT_CLASS = 'float-left';
export const LOCAL = 'local';

export const isDev = () => window.location.hostname
  .split('.').length === FIVE ||
  window.location.hostname === LOCAL_HOST;

export const isLocal = (orgId) => orgId === LOCAL;

export const SENDBIRD_CHAT = '/chat';

export const NUMBER9000000000000000 = 9000000000000000;

export const NUMBER1000000000000000 = 1000000000000000;

export const SEND_BIRD_IV = '78285d4afda511ea';

export const LOCAL_STORAGE_DISPATCH_CONSOLE_PRESET_ID_KEY =
  'dispatchConsoleViewPresetIdList';

export const LOCAL_STORAGE_CAPACITY_PRESET_ID_KEY = 'capcityViewPresetIdList';
export const GEN_AI_ENTITY_CONFIG = 'isGenAIEnabled';
export const GEN_AI_BASE_URL_KEY = 'genAIBaseURL';

export const TWELVE_HR_TIME_FORMAT = { hour12: true, hour: 'numeric', minute: 'numeric' };
export const CHAT_MESSAGE_LIMIT = 20;

export const ERROR_INVALID_API_TOKEN = 400401;
export const ERROR_INVALID_SESSION_TOKEN = 400303;
export const ERROR_REVOKE_SESSION_TOKEN = 400310;
export const ERROR_INVALID_ACCESS_TOKEN = 400302;
export const ERROR_USER_NOT_FOUND = 400301;
export const ERROR_UNAUTHORIZED_REQUEST = 400108;

export const sendbirdSessionErrors = [
  ERROR_INVALID_API_TOKEN,
  ERROR_INVALID_SESSION_TOKEN,
  ERROR_REVOKE_SESSION_TOKEN,
  ERROR_INVALID_ACCESS_TOKEN,
  ERROR_USER_NOT_FOUND,
  ERROR_UNAUTHORIZED_REQUEST
];
